// extracted by mini-css-extract-plugin
module.exports = {"divider":"PageUIDivider_divider__y2AMT"};